import store from '@/store/index.js'
let dic = store.state.dic;

import { validatePhone, validatePhoneCorrect } from "@/libs/elementChecker";

export default function Configs(that) {

    const tableColumns = [
        {
            label: "随行亲友关系",
            prop: "relationship",
            align: "center",
            show: true
        },
        {
            label: "亲友姓名",
            prop: "name",
            align: "center",
            show: true
        },
        {
            label: "联系方式",
            prop: "contactPhone",
            align: "center",
            show: true
        },
        {
            label: "操作",
            name: 'custom',
            align: "center",
            show: true
        },
    ]
    const formItems = [
        {
            label: "姓名",
            span: 12,
            disabled: true,
            model: "name",
        },
        {
            label: "身份证号",
            span: 12,
            disabled: true,
            model: "idCard",
        },

        {
            label: "预到校日期",
            span: 12,
            model: "arriveSchoolTime",
            type: 'date',
            placeholder: '请选择到校时间',
        },
        {
            label: "预到校时间",
            span: 12,
            model: "timeType",
            type: 'select',
            placeholder: '请选择到校时间',
            options: [
                { label: '上午', value: 1 },
                { label: '下午', value: 2 },
                { label: '晚上', value: 3 },
            ],
        },
        {
            label: "联系方式",
            span: 12,
            model: "contactPhone",
            placeholder: '请输入联系方式',
        },
        {
            label: "到校交通方式",
            span: 12,
            model: "trafficType",
            type: 'select',
            // options: [
            //     { label: '亲友驾车', value: '亲友驾车' },
            //     { label: '自乘', value: '自乘' },
            //     { label: '校迎新车辆', value: '校迎新车辆' },
            // ],
            options: dic._TRANSPORT_OPTIONS,
        },

    ]
    const formItems2 = [
        {
            label: "到达站",
            span: 24,
            model: "welcomeStation",
            type: 'select',
            placeholder: '请选择到达站',
            options: [
                { label: '武汉站', value: '武汉站' },
                { label: '汉口站', value: '汉口站' },
                { label: '武昌站', value: '武昌站' },
            ]
        },
        // {
        //     label: "到站时间",
        //     span: 12,
        //     model: "arriveStationTime",
        //     type: 'datetime',
        //     placeholder: '请选择到站时间',
        // },
        // {
        //     label: "车次信息",
        //     span: 12,
        //     model: "trainInfo",
        //     placeholder: '请输入车次',
        // },
    ]
    const formItems3 = [
        {
            label: "车次/班次/车牌号信息",
            span: 24,
            model: "trainInfo",
            placeholder: '请输入车次/班次/车牌号信息',
        },

    ]

    const formRules = {

        contactPhone: [{
            required: true,
            trigger: "blur",
            validator: validatePhone,
        }],
        arriveSchoolTime: [{
            required: true,
            trigger: "blur",
            message: '请选择到校日期'
        }],
        trafficType: [{
            required: true,
            trigger: "blur",
            message: '请选择到校时间'
        }],
        welcomeStation: [{
            required: true,
            trigger: "blur",
            message: '请选择到达站'
        }],
        arriveStationTime: [{
            required: true,
            trigger: "blur",
            message: '请选择到站时间'
        }],
        // trainInfo: [{
        //     required: true,
        //     trigger: "blur",
        //     message: '请输入车次'
        // }],
        timeType: [{
            required: true,
            trigger: "chagne",
            message: '请选择'
        }],
    }
    return {
        // searchItems,
        tableColumns,
        formItems,
        formItems2,
        formItems3,
        formRules
    }
}
